import React from "react";

export default React.createContext({
	token: null,
	userId: null,
	login: () => {},
	logout: () => {},
	setPipedriveDealId: () => {},
	setOrcamentoId: () => {}
});

// export const initialState = {
//     token: null,
//     userId: null,
//     login: () => {},
//     logout: () => {},
// };

// const AuthContext = React.createContext(initialState);

// export default AuthContext;
